module.exports = __webpack_public_path__ + "img/carousel-vet-7.b872577d.jpg";